module.exports = __webpack_public_path__ + "img/5.ae54481c.jpg";